import { atom } from "recoil";

export const freespinsRulesStore = atom({
	key: "freespinsRulesStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "createdAt",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
